import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $MessagesModuleName } from "./messages.types";

const getMessages = (state: IState) =>
    getValueState(state, $MessagesModuleName) || [];

export { getMessages };
